import axios from 'axios';

const webApi = axios.create({
  baseURL: process.env.REACT_APP_WEB_API_URL || process.env.REACT_APP_API_URL || '',
});

webApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('mgl_web_access_token') || localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getEnterpriseSetupApi = () => webApi.get('/api/web/enterprise/setup');
export const createEnterpriseSetupApi = (body) => webApi.post('/api/web/enterprise/setup', body);
export const updateEnterpriseSetupApi = (orgId, body) => webApi.put(`/api/web/enterprise/setup/${orgId}`, body);
export const getEnterpriseSetupStatusApi = (orgId) => webApi.get(`/api/web/enterprise/setup/${orgId}/status`);
/** @deprecated Use updateEnterpriseSetupApi — billing contact is on PUT /setup/:orgId */
export const updateBillingContactApi = (orgId, body) => webApi.put(`/api/web/enterprise/setup/${orgId}/billing-contact`, body);
export const getPricingPreviewApi = (orgId) => webApi.get(`/api/web/enterprise/setup/${orgId}/pricing-preview`);
export const getReferralPreviewApi = (orgId) => webApi.get(`/api/web/enterprise/setup/${orgId}/referral-preview`);
export const getEnterpriseInviteApi = (orgId) => webApi.get(`/api/web/enterprise/setup/${orgId}/invite`);
export const getPricingTableApi = () => webApi.get('/api/web/enterprise/pricing-table');
export const completeEnterpriseSetupApi = (orgId) => webApi.post(`/api/web/enterprise/setup/${orgId}/complete`);
export const submitAchBillingApi = (orgId, body) => webApi.post(`/api/web/enterprise/setup/${orgId}/billing/ach`, body);
export const createStripeCheckoutApi = (orgId, body) => webApi.post(`/api/web/enterprise/setup/${orgId}/billing/checkout-session`, body);
export const uploadRosterApi = (orgId, file) => {
  const form = new FormData();
  form.append('rosterFile', file);
  return webApi.post(`/api/web/enterprise/setup/${orgId}/roster`, form);
};
